import ImageFlow from '@/modules/adjusterReportModules/IncidentParticipants/pages/common/imageFlow/ImageFlow';
import {
  INITIAL_ADJUSTER_IMAGES_LINKS,
  INITIAL_VISIT_ADJUSTER_IMAGES_LINKS,
} from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitLink';
import { useNavigate, useParams } from 'react-router-dom';

const InitialVisitImageFlow = () => {
  const navigate = useNavigate();
  const params = useParams();

  const finishFlow = () => {
    navigate(
      INITIAL_VISIT_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_LOCAL_IMAGE_PREVIEW(
        params.id!,
      ),
      { replace: true },
    );
  };
  const navigateBack = () => {
    navigate(
      INITIAL_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_VEHICLE_IMAGES.edit(
        params.id!,
      ),
      { replace: true },
    );
  };
  return (
    <ImageFlow
      finishFlow={finishFlow}
      navigateBack={navigateBack}
      filetype="initial"
    />
  );
};

export default InitialVisitImageFlow;
